import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import OInput from '../../../../../UI/FormControls/OInput';
import { useTranslation } from 'react-i18next';
import TextArea from '../../../../../UI/FormControls/TextArea';
import DragAndDrop from '../../../../../UI/DragAndDrop';
import OAutocomplete from '../../../../../UI/MuiAutocomplete';
import CheckBox from '../../../../../UI/FormControls/CheckBox';
import MyButton from '../../../../../UI/myButton/MyButton';

const Inputs = ({
  formData,
  setFormData,
  handleSlika,
  slika,
  kategorijaDelova,
}) => {
  const { t, i18n } = useTranslation();
  const [disable, setDisable] = useState(true);
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    console.log(name);
    console.log(event.target.checked);
    if (typeof formData[name] === 'boolean') {
      setFormData((curr) => {
        return { ...curr, [name]: event.target.checked };
      });
    } else {
      setFormData((prevData) => ({ ...prevData, [name]: value }));
    }
  };
  const handleClickKategorijaDelova = (item) => {
    setFormData((curr) => {
      return {
        ...curr,
        idKategorijeDela: item.id,
        nazivKategorijeDela: item.vrednost,
        marza: null,
        marzaCount: (+item.marza).toFixed(2),
        prodajnaCena: item.marza
          ? (+formData.nabavnaCena * (1 + item.marza / 100)).toFixed(2)
          : '',
      };
    });
    setDisable(true);
  };
  const handleUnesiMarzu = (item) => {
    setDisable(false);
  };

  const countPrice = (event) => {
    if (event.target.name === 'nabavnaCena') {
      setFormData((curr) => {
        const value = +event.target.value;
        const calculatedPrice =
          value * (1 + (formData.marza || formData.marzaCount) / 100);
        return {
          ...curr,
          prodajnaCena: value === 0 ? '' : calculatedPrice.toFixed(2),
          [event.target.name]: value === 0 ? '' : value.toFixed(2),
        };
      });
    }
    if (event.target.name === 'prodajnaCena') {
      if (+event.target.value === formData.prodajnaCena) {
        return;
      }
      setFormData((curr) => {
        return {
          ...curr,
          marza: (
            (+event.target.value / +formData.nabavnaCena - 1) *
            100
          ).toFixed(2),
          [event.target.name]: (+event.target.value).toFixed(2),
        };
      });
    }
    if (event.target.name === 'marza') {
      setFormData((curr) => {
        return {
          ...curr,
          prodajnaCena: (
            formData.nabavnaCena *
            (1 + +event.target.value / 100)
          ).toFixed(2),
          [event.target.name]: (+event.target.value).toFixed(2),
        };
      });
    }
  };
  useEffect(() => {
    // na editu kada se marza ne vrati kroz listu nego je null izvlaci se iz kategorijaDelova
    const foundItem = kategorijaDelova.find(
      (item) => item.id === formData.idKategorijeDela,
    );
    if (foundItem) {
      setFormData((curr) => ({
        ...curr,
        marzaCount: foundItem.marza,
      }));
    }
  }, [formData.idKategorijeDela]);
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        marginBottom: '20px',
      }}
    >
      <OInput
        label={t('name')}
        name="naziv"
        value={formData.naziv}
        handleChange={handleInputChange}
      />
      <OInput
        label={t('partNumber')}
        name="partNumber"
        value={formData.partNumber}
        handleChange={handleInputChange}
      />
      <TextArea
        label={t('description')}
        name="opis"
        value={formData.opis}
        handleChange={handleInputChange}
        style={{ width: '100%', height: '60px' }}
      />
      <OAutocomplete
        data={kategorijaDelova}
        value={formData.nazivKategorijeDela || ''}
        handleClick={handleClickKategorijaDelova}
        label="Kategorija"
        style={{ width: '100%', height: '60px' }}
      />
      <OInput
        type="number"
        label="Nabavna cena"
        name="nabavnaCena"
        value={formData.nabavnaCena}
        handleChange={handleInputChange}
        onBlur={countPrice}
      />
      <div style={{ display: 'flex', gap: '10px' }}>
        <OInput
          type="number"
          label="Marža (%)"
          name="marza"
          value={
            formData.marza === 0
              ? '0'
              : formData.marza !== null
              ? formData.marza
              : formData.marzaCount
          }
          handleChange={handleInputChange}
          disabled={disable}
          onBlur={countPrice}
          style={{ width: '70%' }}
        />
        <MyButton
          onClick={handleUnesiMarzu}
          label="Unesi maržu ručno"
          icon="fas fa-pen"
          style={{ width: '30%' }}
        />
      </div>
      <OInput
        type="number"
        label="Prodajna cena"
        name="prodajnaCena"
        value={formData.prodajnaCena}
        handleChange={handleInputChange}
        onBlur={countPrice}
      />
      <div style={{ display: 'flex', gap: '10px' }}>
        <CheckBox
          style={{ height: '70px' }}
          label="Favorit"
          handleChange={handleInputChange}
          checked={formData.favorit}
          name="favorit"
        />
        <CheckBox
          style={{ height: '70px' }}
          label="Akcija"
          handleChange={handleInputChange}
          checked={formData.akcija}
          name="akcija"
        />
      </div>

      <div style={{ display: 'flex' }}>
        <div style={{ flex: '1' }}>
          <DragAndDrop
            handleFiles={handleSlika}
            maxFiles={1}
            addedFiles={slika}
            handleRemoveFile={() => {
              handleSlika([]);
            }}
            title="Dodavanje slike dela"
          />
        </div>
        <div style={{ flex: '1', textAlign: 'center' }}>
          <img
            style={{ height: '120px' }}
            alt="noImage"
            src={`data:image/jpeg;base64,${formData.slikaB64}`}
          />
        </div>
      </div>
    </div>
  );
};

Inputs.propTypes = {
  formData: PropTypes.object.isRequired,
  setFormData: PropTypes.func.isRequired,
};

export default Inputs;
